export default function SiteBackground() {
  return (
    <div className="in-bg" aria-hidden="true">
      <div className="in-bg__orb in-bg__orb--1" />
      <div className="in-bg__orb in-bg__orb--2" />
      <div className="in-bg__orb in-bg__orb--3" />
      <div className="in-bg__grid" />
    </div>
  );
}
